import { BaseButton, TopNavItem, TopNavLeft, TopNavRight } from '@enter/core';
import { mdiMenu, mdiMessageTextOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { ClaimSearchBar, CompanyButton, ProviderMessagingContext, UserButton } from 'components';
import { inject, observer } from 'mobx-react';
import React, { useContext } from 'react';
import { getRouteClaimId, getRouteGuarantorId } from 'services';
import { IInjectedRootStore } from 'stores';
import * as pkg from '../../../package.json';
import logoBlue from './logo-enter-blue.svg';
import enterLogo from './logo-enter.svg';
import * as S from './main.topnav.styles';

type IMainTopnavProps = IInjectedRootStore;

export const MainTopnav: React.FunctionComponent<IMainTopnavProps> = inject('rootStore')(
    observer(
        (props: IMainTopnavProps): React.ReactElement => {
            const messagingContext = useContext(ProviderMessagingContext);
            const { rootStore } = props;
            const { layoutStore } = rootStore;
            const description = `Provider Dashboard v${pkg.version}`;

            const openMessages = () => {
                const claimId = getRouteClaimId();
                const guarantorId = getRouteGuarantorId();

                messagingContext.openPanel?.({ claimId, guarantorId });
            };

            const toggleSidebar = () => {
                layoutStore.toggleSidebar();
            };

            return (
                <S.MainNav>
                    <S.SidebarPanel light={layoutStore.sidebarCollapsed}>
                        <S.DesktopItem>
                            <S.MenuButton
                                variant={layoutStore.sidebarCollapsed ? 'outlined' : 'primary'}
                                onClick={toggleSidebar}>
                                <Icon path={mdiMenu} size={1} />
                            </S.MenuButton>
                        </S.DesktopItem>
                        <S.MobileItem>
                            <S.MenuButton variant="primary" onClick={toggleSidebar}>
                                <Icon path={mdiMenu} size={1} />
                            </S.MenuButton>
                        </S.MobileItem>

                        <S.DesktopItem>
                            <S.Logo
                                src={!layoutStore.sidebarCollapsed ? enterLogo : logoBlue}
                                alt={description}
                                title={description}
                            />
                        </S.DesktopItem>
                        <S.MobileItem>
                            <S.Logo src={enterLogo} alt={description} title={description} />
                        </S.MobileItem>
                    </S.SidebarPanel>
                    <TopNavLeft>
                        <TopNavItem>
                            <S.SearchBarWrapper>
                                <ClaimSearchBar />
                            </S.SearchBarWrapper>
                        </TopNavItem>
                    </TopNavLeft>
                    <S.Spacer />
                    <TopNavRight>
                        <S.DesktopItem>
                            <CompanyButton companyName={rootStore.companyName} />
                        </S.DesktopItem>
                        <TopNavItem>
                            <BaseButton variant="fab-light" size="medium" onClick={openMessages}>
                                <S.StyledIcon path={mdiMessageTextOutline} size={1} />
                            </BaseButton>
                        </TopNavItem>
                        <TopNavItem>
                            <UserButton rootStore={rootStore} />
                        </TopNavItem>
                    </TopNavRight>
                </S.MainNav>
            );
        },
    ),
);
